import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { API_URL } from "../../../config";

const GrantModuleModal = ({
  isOpen,
  toggle,
  customer,
  allModules,
  distributorId,
  onSuccess,
}) => {
  const [selectedRegIdx, setSelectedRegIdx] = useState(0);
  const [selectedModuleIds, setSelectedModuleIds] = useState([]);
  const [granting, setGranting] = useState(false);
  const [message, setMessage] = useState(null);

  const registrations = customer?.allRegistrations || [];
  const currentReg = registrations[selectedRegIdx] || {};

  const grantedModuleIds = new Set();
  (currentReg.cart_details || []).forEach((cart) => {
    (cart.modules || []).forEach((m) => grantedModuleIds.add(String(m.id)));
  });

  useEffect(() => {
    setSelectedModuleIds([]);
    setMessage(null);
  }, [isOpen, selectedRegIdx]);

  const handleToggleModule = (moduleId) => {
    const id = String(moduleId);
    if (grantedModuleIds.has(id)) return;
    setSelectedModuleIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleGrant = async () => {
    if (selectedModuleIds.length === 0) return;
    setGranting(true);
    setMessage(null);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await fetch(
        `${API_URL}/distributor/grant-module-access/${distributorId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
          body: JSON.stringify({
            order_id: currentReg.order_id,
            module_ids: selectedModuleIds.map(Number),
          }),
        }
      );
      const res = await response.json();
      if (res.status) {
        setMessage({
          type: "success",
          text: res.message || "Module access granted successfully",
        });
        setSelectedModuleIds([]);
        if (onSuccess){
          onSuccess()
          toggle()
        } ;
      } else {
        setMessage({ type: "error", text: res.message || "Failed to grant module access" });
      }
    } catch (err) {
      setMessage({ type: "error", text: err.message || "Server error" });
    } finally {
      setGranting(false);
    }
  };

  const ownerName = `${customer?.ownerfirstname || ""} ${customer?.ownerlastname || ""}`.trim();
  const avatarChar = ownerName.charAt(0).toUpperCase();

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      className="grant-module-modal"
      size="lg"
    >
      <ModalHeader toggle={toggle} style={{ color: "#fff" }}>
        Grant Module Access
      </ModalHeader>

      <ModalBody>
        {customer && (
          <div className="grant-module-content">
            {/* Customer info strip */}
            <div className="grant-module-customer-info">
              <span className="grant-module-avatar">{avatarChar}</span>
              <div>
                <div className="grant-module-name">{ownerName || "N/A"}</div>
                <div className="grant-module-email">{customer.email}</div>
              </div>
            </div>

         

            {/* Module checklist */}
            {registrations.length > 0 && (
              <div className="grant-module-list">
                <div className="grant-module-list-header">
                  <span>Available Modules</span>
                  {selectedModuleIds.length > 0 && (
                    <span className="grant-module-selected-count">
                      {selectedModuleIds.length} selected
                    </span>
                  )}
                </div>

                {allModules.length === 0 ? (
                  <div className="grant-module-empty">No modules available</div>
                ) : (
                  <div className="grant-module-grid">
                    {allModules.map((module) => {
                      const isGranted = grantedModuleIds.has(String(module.id));
                      const isSelected = selectedModuleIds.includes(String(module.id));
                      return (
                        <label
                          key={module.id}
                          className={`module-checkbox-row${isGranted ? " is-granted" : ""}${isSelected ? " is-selected" : ""}`}
                        >
                          <input
                            type="checkbox"
                            checked={isGranted || isSelected}
                            disabled={isGranted}
                            onChange={() => handleToggleModule(module.id)}
                          />
                          <span className="module-checkbox-name">{module.name}</span>
                          {/* {isGranted && (
                            <span className="module-granted-badge">Already Granted</span>
                          )} */}
                        </label>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

            {/* Feedback message */}
            {message && (
              <div className={`grant-module-message ${message.type}`}>
                <i
                  className={`fas fa-${
                    message.type === "success" ? "check-circle" : "exclamation-circle"
                  }`}
                ></i>
                {message.text}
              </div>
            )}
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <button
          className="btn-primary-modern"
          onClick={handleGrant}
          disabled={granting || selectedModuleIds.length === 0 || registrations.length === 0}
        >
          {granting ? (
            <>
              <span className="btn-spinner"></span>
              Granting...
            </>
          ) : (
            <>
              <i className="fas fa-unlock-alt"></i>
              Grant Access
              {selectedModuleIds.length > 0 ? ` (${selectedModuleIds.length})` : ""}
            </>
          )}
        </button>
        <button onClick={toggle} className="btn-secondary-modern">
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default GrantModuleModal;
